import styled from '@emotion/styled';
import React from 'react';
import { Divider } from '../../../components/divider/Divider';
import { device } from '../../../styles/devices';
import { typography } from '../../../styles/typography';

const Host = styled.h2`
  ${typography.h2}
`;

interface IProps {
  text: string;
}

const CustomDivider = styled(Divider)`
  margin: 31px 0 25px;
  background-color: currentColor;

  @media ${device.tablet} {
    margin: 10% 0;
  }

  @media ${device.pageLimit} {
    margin: 31px 0 25px;
  }
`;

export function FormTitle({ text }: IProps) {
  return (
    <>
      <Host>{text}</Host>
      <CustomDivider />
    </>
  );
}
